import React from 'react';
import { Badge } from '../../ui/badge';
import { Button } from '../../ui/button';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../ui/table';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';
import { RotateCcw } from 'lucide-react';

export default function VersionsDialog({ open, onOpenChange, versions, onRestore }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Version History</DialogTitle>
        </DialogHeader>
        <div className="max-h-96 overflow-y-auto">
          {versions.length === 0 ? (
            <p className="text-muted-foreground text-center py-4">No versions found</p>
          ) : (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Date</TableHead>
                  <TableHead>Updated By</TableHead>
                  <TableHead>Note</TableHead>
                  <TableHead className="text-right">Action</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {versions.map((version, index) => (
                  <TableRow key={version.id}>
                    <TableCell>
                      {new Date(version.updated_at).toLocaleString()}
                    </TableCell>
                    <TableCell>{version.updated_by}</TableCell>
                    <TableCell className="text-muted-foreground">
                      {version.change_note || '-'}
                    </TableCell>
                    <TableCell className="text-right">
                      {index > 0 ? (
                        <Button
                          variant="ghost"
                          size="sm"
                          onClick={() => onRestore(version.id)}
                        >
                          <RotateCcw className="w-4 h-4 mr-1" />
                          Restore
                        </Button>
                      ) : (
                        <Badge variant="outline">Current</Badge>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
